export default __webpack_public_path__ + "static/media/Desktop-ModelY.30acb76a.jpeg";